export default {
	state: {
		shops: [
			{
				id: '001',
				street: 'Советской Конституции, дом 30',
				point: 'МАГНИТ'
			},
			{
				id: '002',
				street: 'Харьковская, д. 201',
				point: 'ЛЕНТА'
			}
		]
	},
	mutations: {},
	actions: {},

	getters: {
		getNovoshahtinsk (state) {
			return state.shops
		}
	}
}